import { Phone, CalendarCheck } from "lucide-react";
import { CONTACT } from "../data/content";

export const StickyCallBar = ({ onEnquire }) => {
  return (
    <div
      data-testid="sticky-call-bar"
      className="md:hidden fixed bottom-0 left-0 w-full z-40 flex shadow-[0_-4px_24px_rgba(0,0,0,0.18)]"
    >
      <a
        href={CONTACT.phoneHref}
        data-testid="sticky-call-button"
        className="flex-1 bg-[#243E2C] text-[#F6F5F0] py-4 flex items-center justify-center gap-2 text-sm uppercase tracking-[0.15em]"
      >
        <Phone size={17} /> Call
      </a>
      <button
        onClick={onEnquire}
        data-testid="sticky-enquire-button"
        className="flex-1 bg-[#C4A575] text-primary py-4 flex items-center justify-center gap-2 text-sm uppercase tracking-[0.15em] font-medium"
      >
        <CalendarCheck size={17} /> Enquire
      </button>
    </div>
  );
};
